export default function Items({
  id,
  desc,
  quantity,
  onDeleteItem,
  onToggleItem,
  picked,
}) {
  return (
    <li>
      <input
        type="checkbox"
        onChange={() => onToggleItem(id)}
        value={picked}
        className="checked:bg-orange-500 mr-2"
      />
      <span className={picked ? "line-through" : ""}>
        {quantity} {desc}
      </span>
      <button className="mx-2" onClick={() => onDeleteItem(id)}>
        ❌
      </button>
    </li>
  );
}
